<ng-container *ngIf="loadedContactId && loadedContactId === contactId">
  <customer-call-plan-overview *ngIf="contactCallPlan; else noCallPlan" [period]="period" [detailsOnly]="true" [previewRows]="preview ? 2 : null" (openList)="openCallPlanList($event)" data-testid="contact-plan-overview"></customer-call-plan-overview>
  <ng-template #noCallPlan>
    <ind-section-header [viewData]="emptyHeader" data-testid="contact-plan-empty-header"></ind-section-header>
    <div class="no-data-message" data-testid="contact-plan-empty">{{ 'NO_CALL_PLANS' | translate }}</div>
  </ng-template>
</ng-container>
